/**
 * CONSTANTS
 */
export const ARNEO_ECOCONCEPTION_AUDITOR = 'ARNEO_ECOCONCEPTION_AUDITOR';
export const ARNEO_ECOCONCEPTION_USER_EMAIL = 'ARNEO_ECOCONCEPTION_USER_EMAIL';
export const ARNEO_ECOCONCEPTION_ACCESS_TOKEN =
  'ARNEO_ECOCONCEPTION_ACCESS_TOKEN';
export const ARNEO_ECOCONCEPTION_CROWD_TOKEN =
  'ARNEO_ECOCONCEPTION_CROWD_TOKEN';

/**
 * API
 */
// AUDIT
export const API_AUDIT_ANALYZE = '/api/analyzer';
export const API_AUDIT_GENERATE = '/api/excel';
export const API_AUDIT_DRIVE = '/api/google/drive/create';

// CROWD
export const API_CROWD_LOGIN = '/api/crowd';
export const API_CROWD_TOKEN = '/api/crowd/check_token';
